var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'item-attr mb-2',
    _vm.isShowingEditUI ? 'interactive' : 'static',
    { 'placeholder--item-attr': _vm.placeholder },
    { unselected: _vm.unselected } ],on:{"mouseover":_vm.mouseover,"mouseleave":_vm.mouseleave}},[_c('div',{class:['item-attr--title', { hover: _vm.hover }]},[_vm._v(_vm._s(_vm.attr.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }